<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-24 15:52:50
 * @FilePath: 
 * @Description: 充值售卡提成
-->
<template>
  <div class="c-p-t-20 full_page_grey">
    <date-tab-com
      ref="dateTabRef"
      @change="handleChangeDateType"
      @changeDate="handleChangeDateData"
    ></date-tab-com>

    <ul class="statistics_item_con">
      <li>
        <p class="c-ft-24">售卡充值业绩</p>
        <div class="statistics_count_con">{{ totalObj.Receipts }}</div>
      </li>
      <li>
        <p class="c-ft-24">推销会员人数</p>
        <div class="statistics_count_con">{{ totalObj.MemberCount }}</div>
      </li>
      <li>
        <p class="c-ft-24">充值售卡提成</p>
        <div class="statistics_count_con">{{ totalObj.Commission }}</div>
      </li>
    </ul>
    <ul class="account_list_con">
      <van-list
        v-model="loading"
        :error.sync="loadError"
        :immediate-check="false"
        :finished="finished"
        :offset="30"
        error-text="请求失败，点击重新加载"
        @load="onShowMore"
      >
        <li v-for="(item, index) in accountList" :key="index" class="m-b-20">
          <div class="p-tb-20 p-l-20">
            <div class="c-f account_info_con m-b-10">
              <p class="c-f w-38%">
                <span>手机号：</span><i>{{ item.MobilePhone }}</i>
              </p>
              <p class="w-62% c-f">
                <span class="right_con">充值售卡时间：</span
                ><i>{{ item.OperateDate }}</i>
              </p>
            </div>
            <div class="c-f account_info_con">
              <p class="w-38% c-f">
                <span>会员姓名：</span><i>{{ item.MemberName }}</i>
              </p>
              <p class="w-62% c-f">
                <span class="right_con">充值售卡提成：</span
                ><i>{{ item.Commission }}</i>
              </p>
            </div>
          </div>
          <div class="c-f c-ft-25 account_title_con">
            <p class="f-2 tc p-tb-15">会员卡号</p>
            <p class="f-1 tc p-tb-15">会员卡</p>
            <p class="f-1 tc p-tb-15">充值金额</p>
            <p class="f-1 tc p-tb-15">提成</p>
          </div>
          <div class="c-f c-ft-25" v-for="(v, i) in item.Consumes" :key="i">
            <p class="f-2 tc p-tb-15">
              {{ v.CardCode }}
            </p>
            <p class="f-1 tc p-tb-15">{{ v.CardType }}</p>
            <p class="f-1 tc p-tb-15">{{ v.OrigMoney }}</p>
            <p class="f-1 tc p-tb-15">{{ v.Commission }}</p>
          </div>
        </li>
      </van-list>
    </ul>
  </div>
</template>

<script>
import DateTabCom from "./comps/dateTabCom.vue";
import { getSalesCardInfo } from "@/api/performance";
export default {
  name: "SaleCardTicheng",
  props: {},
  data() {
    return {
      pageIndex: 0,
      allPage: 0,
      pageSize: 5,
      loading: false,
      finished: false,
      loadError: false,
      totalObj: {
        Receipts: "--",
        MemberCount: "--",
        Commission: "--",
      },
      accountList: [],
    };
  },
  components: { DateTabCom },
  created() {},

  mounted() {
    this.$nextTick(() => {
      this.dateType = this.$refs.dateTabRef.nowDateType;
      this.handleGetSalesCardInfo();
    });
  },
  methods: {
    handleChangeDateType(type) {
      this.dateType = type;
      if (type !== 4) {
        this.resetParams();
        this.handleGetSalesCardInfo();
      }
    },
    handleChangeDateData(dateArr) {
      this.startDate = dateArr[0];
      this.endDate = dateArr[1];
      this.resetParams();
      this.handleGetSalesCardInfo();
    },
    resetParams() {
      this.loadError = false;
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.accountList = [];
      this.totalObj = {
        Receipts: "--",
        MemberCount: "--",
        Commission: "--",
      };
    },

    handleGetSalesCardInfo() {
      const queryData = {
        Query: {
          TimeType: this.dateType,
          VpnId: this.$store.state.vpnId,
        },
        Pager: {
          PageIndex: this.pageIndex,
          PageSize: this.pageSize,
        },
      };
      if (this.dateType == 4) {
        queryData.Query.BeginTime = this.startDate;
        queryData.Query.EndTime = this.endDate;
      }
      getSalesCardInfo(queryData)
        .then((res) => {
          this.totalObj = res.Total;
          let resDatas = res.Items;
          // this.allPage = res.Pager.TotalPage;
          if (resDatas instanceof Array) {
            this.accountList = this.accountList.concat(resDatas);
            if (this.accountList.length >= res.Pager.TotalCount) {
              this.finished = true;
            }
          }
          this.loading = false;
        })
        .catch((err) => {
          // console.log(err)
          this.loadError = true;
          this.loading = false;
        });
    },
    // 上拉加载
    onShowMore() {
      console.log(this.loadError);
      // if (this.pageIndex + 1 < this.allPage) {
      this.pageIndex += 1;
      this.handleGetSalesCardInfo();
      // }
    },
  },
};
</script>
<style scoped lang="scss">
.statistics_item_con {
  display: flex;
  padding: 20px;
  li {
    flex: 1;
    padding: 30px 0;
    border: 1px solid #eee;
    background: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 10px;

    &:nth-child(3n) {
      margin-right: 0;
    }
    .statistics_count_con {
      font-size: 30px;
      font-weight: bold;
      margin-top: 10px;
    }
  }
}
.account_list_con {
  margin: 0 20px;
  li {
    background: #fff;
    border-radius: 10px;
  }

  .account_info_con {
    font-size: 24px;
    span {
      width: 120px;
      font-weight: bold;
      &.right_con {
        width: 190px;
      }
    }
  }
  .account_title_con {
    background: #eee;
  }
}
</style>
